import ActionDropdown from "../../../common/AdminCommonComponents/Buttons/ActionDropdown/ActionDropdown"
import DatatableComponent from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import styles from './PartnerWarehouses.module.scss'
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"

const PartnerWarehouses = ({ setShowWarehouseDetails }) => {
  const handleViewDetails = () => setShowWarehouseDetails(true);
  const handleEdit = () => console.log("Edit action executed");
  const handleChangeStatus = () => console.log("Change Status action executed");
  const handleDelete = () => console.log("Delete action executed");

  const dropdownOptions = [
    { label: "View details", action: handleViewDetails },
    { label: "Edit", action: handleEdit },
    { label: "Change Status", action: handleChangeStatus },
    { label: "Delete", action: handleDelete, disabled: false },
  ];

  const data = [
    {
      warehouseId: "WH-1001",
      partnerName: "abc Logistics",
      location: "new york, usa",
      capacity: "10,000 units",
      availableSpace: "2500 units",
      status: "Active",
    },
    {
      warehouseId: "WH-1002",
      partnerName: "global warehouse",
      location: "berlin, germany",
      capacity: "5000 units",
      availableSpace: "500 units",
      status: "Inactive",
    },
    {
      warehouseId: "WH-1002",
      partnerName: "global warehouse",
      location: "berlin, germany",
      capacity: "5000 units",
      availableSpace: "500 units",
      status: "Inactive",
    },
    {
      warehouseId: "WH-1002",
      partnerName: "global warehouse",
      location: "berlin, germany",
      capacity: "5000 units",
      availableSpace: "500 units",
      status: "Inactive",
    },
    {
      warehouseId: "WH-1002",
      partnerName: "global warehouse",
      location: "berlin, germany",
      capacity: "5000 units",
      availableSpace: "500 units",
      status: "Inactive",
    },
  ]

  const columns = [
    { name: "Warehouse ID", selector: (row) => row.warehouseId },
    { name: "Partner Name", selector: (row) => row.partnerName },
    { name: "Location", selector: (row) => row.location },
    { name: "Capacity", selector: (row) => row.capacity },
    { name: "Available Space", selector: (row) => row.availableSpace },
    { name: "Status", selector: (row) => row.status },
    { name: 'Action', cell: () => <ActionDropdown options={dropdownOptions} /> }
  ]

  return (
    <>
      <div className={styles["content"]}>
        <div className={styles["info"]}>
          <div className="fw-semibold fs-5">Partner Warehouse Table</div>
          <div>
            <DynamicButton>Add new Partner</DynamicButton>
          </div>
        </div>
      </div>
      <DatatableComponent data={data} columns={columns} type="yellow" />
    </>
  )
}

export default PartnerWarehouses